
import { Injectable } from '@angular/core';
import { SupabaseClientService } from './supabase-client.service';
import { MaterialModel } from '../models/material.model';
import { TimelineItem } from '../../shared/widget/event-viewer-widget/event-viewer-widget';
import { MenuOption } from '../models/menu-options';

@Injectable({
  providedIn: 'root'
})
export class FunctionalitiesService {

  public menuOptions: MenuOption[] = [
    //{ title: 'Register', pill:'violet-french', link: '/auth/signin', roles: ['guest', 'invited'] },
    //{ title: 'Randomizzatore', pill: 'fa-solid fa fa-random', link: '/cu/calc', roles: ['beginner'] },
    //  { title: 'Login', pill: 'fa-solid fa-right-from-bracke', link: '/auth/login', roles: ['guest', 'user'] },
    //{ title: 'Delete Account', pill: 'red', link: '/auth/delete', roles: ['user', 'admin'] },

    //{ title: 'Trading', pill: 'fa-solid fa-robot', link: '/cu/cycles', roles: ['platinum','gold'] },



    //{ title: 'Meetings', pill: 'fa-solid fa-video', link: '/cu/meetings', roles: ['platinum'] },
    { title: 'Dashboard', pill: 'fa-solid fa-table-columns', link: '/cu/dashboard', roles: ['m4n-trading', 'beginner', 'platinum'] },
    { title: 'Trading', pill: 'fa-solid fa-robot', link: '/cu/cycles-new', roles: ['m4n-trading', 'beginner', 'platinum'], isNew: true },
    { title: 'Simulations', pill: 'fa-solid fa-flask', link: '/cu/simulations', roles: ['admin'] },
    { title: 'Messages', pill: 'fa-solid fa-paper-plane', link: '/admin/messages', roles: ['admin'] },
    { title: 'Reports', pill: 'fa-solid fa-chart-line', link: '/cu/reports', roles: ['dev'] },
    { title: 'Manage Plans', pill: 'fa-solid fa-credit-card', link: '/pl/plan-subscription', roles: ['dev'] },
    { title: 'Wiki Firms', pill: 'fa-brands fa-wikipedia-w', link: '/cu/wiki-firm', roles: ['dev'] },
    { title: 'Admin Panel', pill: 'fa-solid fa-screwdriver-wrench', link: '/admin/index', roles: ['admin'] },
    { title: 'Profilo', pill: 'fa-solid fa-user', link: '/auth/pf', roles: ['m4n-trading', 'beginner', 'platinum'] },
    { title: '', pill: 'fa-solid fa-right-from-bracket', link: '/auth/logout', roles: ['user'] },
  ];

}
